/** The KnowYourChord API server (VITE_CHORDS_API, see .env.production); empty = module off. */
export const CHORDS_API = (import.meta.env.VITE_CHORDS_API ?? '').trim().replace(/\/+$/, '');

export const YOUTUBE_ENABLED = CHORDS_API !== '';
